import React from "react";
import { Button, makeStyles } from "@material-ui/core";
import { deleteLifeFromAPI, getLifeFromAPI } from "../helpers";
import { useRecoilState } from "recoil";
import { allLifeAtom } from "../atoms";
import { Life } from "../models";
import DeleteIcon from "@material-ui/icons/Delete";

const useStyle = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  }
});

type IProps = {
  id: string,
}

const DeleteLifeButton = (props: IProps): React.ReactElement => {
  const classes = useStyle();
  const [allLifes, setAllLifes] = useRecoilState(allLifeAtom);

  const onButtonClick = () => {
    getLifeFromAPI(props.id).then(value => {
      if (!value) return;

      // const version = value._version;
      // if (!version) return;

      deleteLifeFromAPI(props.id).then(() => {
        setAllLifes(Array.from(allLifes.values()).reduce((previousValue, currentValue) => {
          if (currentValue.id === props.id) return previousValue;

          return previousValue.set(currentValue.id, currentValue);
        }, new Map<string, Life>()));
      });
    });
  };

  return <Button onClick={onButtonClick} className={classes.wrapper}><DeleteIcon /></Button>;
};

export default DeleteLifeButton;
